<template>
  <div class="public-pdf">
    <form 
      :action="'/api/public/pdf/' + uuid + '?m=' + model"
      method="post"
      ref="pdfForm">
      <input 
        type="hidden"
        name="uuid"
        :value="uuid">
      <input 
        type="hidden"
        name="model"
        :value="model" >
    </form>
  </div>
</template>
<script>
  export default {
    name: 'PublicPdf',
    data () {
      return {
        uuid: '',
        model: ''
      }
    },
    async mounted () {
      if (!this.$route.params.uuid || !this.$route.query.m) {
        this.$router.push('/404')
      } else {
        this.uuid = this.$route.params.uuid
        this.model = this.$route.query.m
        await this.$nextTick()
        this.servePdf()
      }
    },
    methods: {
      servePdf () {
        this.$refs.pdfForm.submit()
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/PublicPdf.vue